import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';

export const useMerchantApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getAllMerchant = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.getAllRestaurantMerchants(query.storeType);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  // Separate function for push notifications - gets all merchants
  const getAllMerchantForPushNotification = useCallback(
    async (params?: {
      search?: string;
      sortBy?: string;
      sortOrder?: 'asc' | 'desc';
      page?: number;
      limit?: number;
    }) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.getMerchants(
          params?.page || 1,
          params?.limit || 100,
          undefined, // storeType
          params?.search && params.search.trim() !== ''
            ? params.search
            : undefined,
          params?.sortBy as any,
          params?.sortOrder as any
        );
        return response.data;
      } catch (err) {
        const errorMessage =
          err instanceof Error
            ? err.message
            : 'An error occurred while fetching merchants';
        setError(errorMessage);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  return {
    getAllMerchant,
    getAllMerchantForPushNotification,
    loading,
    error,
  };
};
